import React from 'react';
import { Wrap, EasyActions, EasyWin, Loader } from '../../components/index';
import * as _ from 'lodash';
import { useResponsivity } from '../../helpers/helpers';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import store from 'store2';
interface KitchenTapProps {
  challenges: any;
  listLocation: any;
  getChallengeCategory: Function;
  completeTask: any;
  completeChallenge: Function;
  generalData: Function;
  getOffers: Function;
}

const KitchenTap: React.FC<KitchenTapProps> = (props) => {
  const {
    challenges,
    getChallengeCategory,
    completeTask,
    completeChallenge,
    generalData,
    getOffers,
  } = props;
  const getRoomId = store('property');

  const data = _.get(challenges, 'data.challenges');
  const offers = _.get(challenges, 'offers.data.challenges');

  const isMobile = useResponsivity();
  const plumberVisit = _.find(offers, function (o) {
    return o.tag.includes('PLUMBER_VISIT');
  });
  const [t] = useTranslation('common');
  const { error, loading, done } = _.get(completeTask, 'status');
  const loadingChallenges = _.get(challenges, 'status.loading');
  React.useEffect(() => {
    getChallengeCategory(getRoomId, 'kitchen-tap');
    getOffers(getRoomId);
  }, [getRoomId]);

  const pageArray = [
    {
      id: 268,
      title: 'Kitchen taps',
      icon: 'faucet',
      description:
        'Kitchen taps and appliances are often overlooked, but can waste significant amounts of water and energy if not used correctly.',
      easyWins: [
        {
          title: 'Engage staff',
          size: 'half',
          hasLogo: false,
          description: [
            'Print off the poster and place within each kitchen to encourage staff to boil only what they need. This poster will reduce water and energy use in your business by as much as 30%.',
          ],
          buttonText: 'Download PDF',
          buttonIcon: 'download',
          linkType: 'button',
          buttonPath:
            'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/posters/gecko.pdf',
          poster:
            'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/posters/gecko.png',
        },

        {
          title: 'Plumber Tips',
          size: 'half',
          icon: 'sink',
          hasLogo: false,
          description: [
            'The simplest way to reduce water use in the kitchen is to encourage staff to wash up using a bowl or putting the plug in the sink – rather than under a running tap. Remember, wasted hot water adds to your business energy bills.',
          ],
        },
        {
          title: 'Fix a leak',
          size: 'half',
          hasLogo: false,
          icon: 'fixLeak',
          buttonText:
            plumberVisit !== undefined
              ? 'Book a Free plumber visit'
              : 'Find a plumber',
          linkType:
            plumberVisit !== undefined ? 'internalLink' : 'externalLink',
          buttonPath:
            plumberVisit !== undefined
              ? '/actions'
              : 'https://www.watersafe.org.uk',
          buttonIcon: null,

          description: [
            'Kitchen taps with a constant drip could be wasting as much as 50 litres every day, even at weekends when staff are at home – which will impact your water bill.',
          ],
        },

        {
          title: 'Smart products',
          theme: 'green',
          size: 'half',
          hasLogo: true,
          icon: null,
          linkType: 'externalLink',
          buttonText: 'Find compact dishwashers',
          buttonPath: 'https://uk.getwatersmart.com/products',
          description: [
            'Better still, dishwashers use very little water and energy and are more water efficient than washing up by hand. Many are designed to fit within small spaces.',
          ],
        },
      ],
    },
  ];

  const getChallenges = () => {
    return _.map(data, (el, index) => {
      const title = _.get(el, 'title');
      const description = _.get(el, 'description');
      const buttonText = _.get(el, 'buttonText');
      const type = _.get(el, 'internalType');
      const buttonPath = _.get(el, 'buttonPath');
      const energySaving = _.get(el, 'energy_saving');
      const carbonSaving = _.get(el, 'carbon_saving');
      const waterSaving = _.get(el, 'water_saving');
      const exType = _.get(el, 'type');
      return (
        <Col xs={12} sm={12} md={12} key={index}>
          <EasyActions
            isDesktop={!isMobile}
            icon={_.get(el, 'icon')}
            id={_.get(el, 'id')}
            title={`${t(title)}`}
            description={`${t(description)}`}
            buttonText={`${t(buttonText)}`}
            buttonPath={buttonPath}
            popup={type === 'direct-redirect' ? false : true}
            renderComplete={() => {
              completeChallenge(getRoomId, _.get(el, 'id'));
              setTimeout(() => {
                getChallengeCategory(getRoomId, 'kitchen-tap');
                generalData();
              }, 1000);
            }}
            isLoading={loading}
            completed={done}
            energySaving={energySaving}
            carbonSaving={carbonSaving}
            waterSaving={waterSaving}
            type={exType}
          />
        </Col>
      );
    });
  };
  if (loadingChallenges) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }

  return (
    <Wrap>
      <EasyWin data={pageArray}>
        {' '}
        <Row>{getChallenges()}</Row>
      </EasyWin>
    </Wrap>
  );
};

export default KitchenTap;
